<template>
  <v-container
    id="templateEdit"
    class="pa-0"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="green"
    />
    <v-row>
      <v-col
        v-for="(answer,i) in answers"
        :key="i"
        :md="(answer.questionScreenWidth || 2) * 3"
        cols="12"
      >
        <div v-if="isNumber(answer)">
          <v-text-field
            v-model="answer.answer"
            :label="answer.question"
            :success="answer.modified"
            :success-messages="answer.messages"
            :error="isEmptyRequired(answer)"
            :disabled="disabled"
            type="number"
            @change="onChange(answer)"
          >
            <v-icon
              v-if="isEmptyRequired(answer)"
              slot="append"
              color="red"
            >
              mdi-alert
            </v-icon>
          </v-text-field>
        </div>
        <div v-else-if="isDate(answer)">
          <base-date-picker
            :date-value.sync="answer.answer"
            :label="answer.question"
            :error="isEmptyRequired(answer)"
            :disabled="disabled"
            @change="onChange(answer)"
          />
        </div>
        <div v-else-if="isBoolean(answer)">
          <v-switch
            v-model="answer.answer"
            :label="answer.question"
            :error="isEmptyRequired(answer)"
            :disabled="disabled"
            @change="onChange(answer)"
          />
        </div>
        <div v-else>
          <v-text-field
            v-model="answer.answer"
            :label="answer.question"
            :success="answer.modified"
            :success-messages="answer.messages"
            :error="isEmptyRequired(answer)"
            :disabled="disabled"
            @change="onChange(answer)"
          >
            <v-icon
              v-if="isEmptyRequired(answer)"
              slot="append"
              color="red"
            >
              mdi-alert
            </v-icon>
          </v-text-field>
        </div>
      </v-col>
      <v-col
        v-if="disabled === false"
        cols="12"
      >
        <v-btn
          class="ma-2"
          color="primary"
          :outlined="!hasChanges()"
          :disabled="saving"
          @click="save()"
        >
          {{ buttonLabel }}
        </v-btn>
        <v-btn
          v-if="deleteLabel != null"
          class="ma-2"
          color="error"
          outlined
          :disabled="saving"
          @click="remove()"
        >
          {{ deleteLabel }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'TemplateEdit',

    props: {
      answers: {
        type: Array,
        default: null,
      },
      buttonLabel: {
        type: String,
        default: 'Save',
      },
      deleteLabel: {
        type: String,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      saving: {
        type: Boolean,
        default: false,
      },
    },

    created () {
      this.initialize()
    },

    methods: {

      initialize () {
        this.transformDataTypes()
      },

      transformDataTypes () {
        if (this.answers && this.answers.length) {
          this.answers.forEach((answer) => {
            if (answer.answer !== null && answer.answer !== undefined) {
              const dataType = this.getType(answer)
              if (dataType === 'boolean') {
                answer.answer = answer.answer.toLowerCase() === 'true'
              } else if (dataType === 'number') {
                answer.answer = Number(answer.answer.toString().replace(/[^0-9.-]+/g, ''))
              }
            }
          })
        }
        return this.answers
      },

      getType (answer) {
        return ((answer || {}).answerDataType || 'string')
      },

      isEmptyRequired (answer) {
        const empty = !(answer || {}).answer
        const required = ((answer || {}).answerRequired || false)
        return (empty && required)
      },

      isNumber (answer) {
        return this.getType(answer) === 'number'
      },

      isDate (answer) {
        return this.getType(answer) === 'date'
      },

      isBoolean (answer) {
        return this.getType(answer) === 'boolean'
      },

      onChange (answer) {
        answer.modified = true
        answer.messages = ['Modified']
        this.$emit('change', answer)
        this.$forceUpdate()
        console.log('changed')
        console.log(answer)
      },

      hasChanges () {
        const modifiedItems = this.modifiedAnswers()
        return modifiedItems && modifiedItems.length > 0
      },

      modifiedAnswers () {
        let modifiedAnswers = []
        if (this.answers && this.answers.length) {
          modifiedAnswers = this.answers.filter((item) => {
            return item.modified
          })
        }
        return modifiedAnswers
      },

      save () {
        this.$emit('save', this.answers, this.modifiedAnswers())
      },

      remove () {
        this.$emit('delete', this.answers)
      },
    },
  }
</script>
